import styles from './MiniRadarChart.module.css';

const MiniRadarChart = ({ title, facets, isLocked, colorClass }) => {
  const facetKeys = facets
    ? Object.keys(facets)
    : ['f1', 'f2', 'f3', 'f4', 'f5', 'f6'];

  const formatFacetName = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const angleSlice = (Math.PI * 2) / 6;

  const getPoint = (value, index, offset = 0) => {
    const angle = angleSlice * index - Math.PI / 2;
    const radius = isLocked ? 25 : (value / 100) * 45;
    const x = 50 + radius * Math.cos(angle);
    const y = 50 + radius * Math.sin(angle);
    return { x, y };
  };

  const dataPoints = (isLocked ? Array(6).fill(50) : Object.values(facets))
    .map((p, i) => {
      const point = getPoint(p, i);
      return `${point.x},${point.y}`;
    })
    .join(' ');

  const axisPoints = Array(6)
    .fill(100)
    .map((p, i) => {
      const point = getPoint(p, i);
      return `${point.x},${point.y}`;
    })
    .join(' ');

  return (
    <div className={styles.chartWrapper}>
      <div className={styles.chartTab}>{title}</div>
      <div
        className={`${styles.miniChartContainer} ${isLocked ? styles.locked : ''}`}
      >
        {isLocked && <i className={`fas fa-lock ${styles.lockIcon}`}></i>}
        <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
          <polygon className={styles.radarGrid} points={axisPoints} />
          <polygon
            className={styles.radarGridInner}
            points={Array(6)
              .fill(66)
              .map((p, i) => {
                const point = getPoint(p, i);
                return `${point.x},${point.y}`;
              })
              .join(' ')}
          />
          <polygon
            className={styles.radarGridInner}
            points={Array(6)
              .fill(33)
              .map((p, i) => {
                const point = getPoint(p, i);
                return `${point.x},${point.y}`;
              })
              .join(' ')}
          />

          {/* --- Display numbers instead of text --- */}
          {facetKeys.map((key, i) => {
            const point = getPoint(100, i, -8); // Position numbers just outside the grid
            return (
              <text
                key={key}
                x={point.x}
                y={point.y}
                className={styles.radarAxisLabel}
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {i + 1}
              </text>
            );
          })}
          <polygon
            className={`${styles.radarData} ${styles[colorClass]}`}
            points={dataPoints}
          />
        </svg>

        {/* --- Legend below the chart --- */}
        <ul className={styles.facetLegend}>
          {facetKeys.map((key, i) => (
            <li key={key}>
              <span className={styles.legendNumber}>{i + 1}.</span>
              {formatFacetName(key)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MiniRadarChart;
